package com.essntl.core.network

enum class NetworkState {
    Available,
    Unavailable,
    Unknown,
}